import * as React from 'react';
export const DeleteDialogContext = React.createContext({
    isClosing: false,
    onClose: () => { },
    setIsClosing: () => { },
});
//# sourceMappingURL=delete-dialog-context.js.map